<template>
  <div class="herder-list">
    <img class="lang-black" @click="changeLang" v-if="false" src="@/assets/image/common/lang-black.png" />
    <div
      class="nav-item"
      v-for="(item, index) in $t('home.mobileHerder')"
      :key="index"
      v-if="item.type === login || item.type === 3"
    >
      <div class="title" @click="close(item.type,item.path)">{{ item.name }}</div>
      <div
        v-if="item.children"
        v-for="(cItem, cIndex) in item.children"
        :key="cIndex"
      >
        <div class="c-title" @click="goUrl(cItem.path)">{{ cItem.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from "vue";
export default {
  data() {
    return {
      active: false,
    };
  },
  methods: {
    close(type,path) {
      if (type === 2) {
        const dom = document.getElementsByClassName("nav-item")[0];
        if (!this.active) {
          this.active = true;
          dom.style.maxHeight = "350px";
        } else {
          this.active = false;
          dom.style.maxHeight = "20.8px";
        }
      } else {
        this.$emit("close");
        this.$router.push(path);
      }
    },
    goUrl(path) {
      this.$router.push(path);
        this.$emit("close");
    },
     changeLang() {
      return
      if (this.$i18n.locale === "zn") {
        // 判断当前语言
        this.$i18n.locale = "en"; // 设置当前语言
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "zn";
        localStorage.setItem("lang", "zn");
      }
    },
  },
  computed: {
    login() {
      let login = 1;
      if (localStorage.getItem("login")) {
        login = 2;
      }
      return login;
    },
  },
};
</script>
<style lang="scss" scoped>
.herder-list {
  display: none;
  position: fixed;
  width: 100%;
  background-color: #fff;
  overflow: auto;
  max-height: calc(100vh - 70px);
  top: 70px;
  .lang-black {
    width: 18px;
    height: 18px;
    margin-top: 16px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .nav-item {
    cursor: pointer;
    margin-bottom: 25px;
    max-height: 20.8px;
    overflow: hidden;
    transition: max-height ease 0.75s;
    .title {
      text-align: center;
      color: #232323;
      font-size: 16px;
      font-weight: bolder;
    }
    .c-title {
      text-align: center;
      color: #232323;
      font-size: 14px;
      margin-top: 22px;
    }
  }
  .nav-item:last-child {
    margin-bottom: 19px;
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1000px) {
  .herder-list {
    display: block;
  }
}
</style>